export default __webpack_public_path__ + "static/media/b38.b6f56a9c.png";